<template>
    <section class="breadcrumb">
        <div class="container">
            <div class="flexrow">
                <ul class="bread">
                    <li><router-link :to="'/'">Főoldal</router-link></li>
                    <li
                        v-for="(item, index) in elements"
                        v-bind:key="'breadcrumb-' + index"
                    >
                        <router-link :to="{ name: item.link }">{{
                            item.name
                        }}</router-link>
                    </li>
                </ul>
                <router-link tag="button" to="/" class="breadbutton">
                    <i class="icon-arrow_2"></i>Vissza a találati listához
                </router-link>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "BreadCrumbs",
    props: ["elements"]
};
</script>

<style scoped></style>
